/** @jsxImportSource @emotion/react */

// React Lib
import React from "react";
import classnames from 'classnames';
// Component Styles
import { useStyles } from "./ButtonStyles";
// @otg-one/ui_components/icons
import ArrowLeft from "../../icons/Arrow/Left";
import ArrowRight from "../../icons/Arrow/Right";
const getIcon = alignment => {
    switch (alignment) {
        case "right":
            return React.createElement(ArrowRight, null);
        case "left":
            return React.createElement(ArrowLeft, null);
    }
};
export const Button = (props) => {
    const classes = useStyles(props);
    const { id, tabIndex = 0, type = "primary", color = "blue", disabled = false, icon, alignIcon, onClick = () => { }, onMouseOver, style, children } = props;
    let iconButton = getIcon(alignIcon);
    /** If icon is supplied from props, replace default arrow icon */
    if (icon) {
        iconButton = icon;
    }
    const buttonClasses = classnames({
        [classes.button]: true,
        [classes[type]]: type,
        [classes[`${type}${color}`]]: `${type}${color}`,
        [classes[`${type}disabled${color}`]]: disabled,
        [classes.withIcon]: typeof alignIcon !== "undefined"
    });
    return (
        <div 
            id={id}
            css={[
                classes.button,
                type && classes[type],
                color && classes[`${type}${color}`],
                disabled && classes[`${type}disabled${color}`],
                typeof alignIcon !== "undefined" && classes.withIcon,
                style
            ]}
            className={buttonClasses}
            onClick={onClick}
            tabIndex={tabIndex}
            onMouseOver={onMouseOver}
        >
            {alignIcon === "left" && (
                <div css={classes.buttonIconLeft}>
                    {iconButton}
                </div>
            )}
            {children}
            {alignIcon === "right" && (
                <div css={classes.buttonIconRight}>
                    {iconButton}
                </div>
            )}
        </div>
    )
};
export default React.memo(Button);
